/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * This resource gathers the contact methods preferred by the Client, such as e-mail, telephone, social media, etc.
 */
export interface ContactMethod {
  /**
   * Unique Id for the contact media
   */
  contactMethodId?: string;
  /**
   * Contact method identifier
   */
  contactMethodTypeCode?: ContactMethod.ContactMethodTypeCodeEnum;
  /**
   * Indicates a subtype in case of Social Media, for example: 01 - Facebook, 02 - Twitter, 03 - Instagram, 04 - Linkedin, 05 - YouTube, 06 - Google plus, 07 - Landline, 08 - Mobile phone, 09 - Email Reminder, 10 - Product Email, 12 - News Email, 13 - Correspondence address
   */
  contactMethodSubTypeCode?: string;
  /**
   * Indicates the value for the contact media according with the type
   */
  contactMethodValue?: string;
  /**
   * Indicates the contact media name
   */
  contactName?: string;
  /**
   * Indicates if the contact media is the preferred by the client
   */
  contactPreferenceInd?: boolean;
  /**
   * Indicates if the contact media is validated
   */
  contactCheckInd?: boolean;
  /**
   * Time slots where the client allows to be reached through the contact media
   */
  contactDaytimeSlot?: string;
}
export namespace ContactMethod {
  export type ContactMethodTypeCodeEnum = 'home' | 'work' | 'mobile' | 'fax' | 'mail';
  export const ContactMethodTypeCodeEnum = {
    Home: 'home' as ContactMethodTypeCodeEnum,
    Work: 'work' as ContactMethodTypeCodeEnum,
    Mobile: 'mobile' as ContactMethodTypeCodeEnum,
    Fax: 'fax' as ContactMethodTypeCodeEnum,
    Mail: 'mail' as ContactMethodTypeCodeEnum,
  };
}
